export default class CtaBack {

	static selector = '[data-cta-back]';

	// class variables

	el = {};

	// constructor

	constructor(container) {
		this.el = {
			container
		};

		this.initialize();
	}

	// init

	initialize() {
		this.#addEventListeners();
	}

	// event listeners

	#addEventListeners = () => {
		this.el.container.addEventListener('click', this.#onClick);
	}

	#removeEventListeners = () => {
		this.el.container.removeEventListener('click', this.#onClick);
	}

	// listener methods

	#onClick = () => {
		window.history.back();
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
